import {Component, ViewChild, OnInit} from '@angular/core';
import { environment } from '../../environments/environment';
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { DateAdapter } from '@angular/material';
import { AuthService } from "../auth.service";
import { UtilsService } from "../shared/shared.module";
import {Observable} from "rxjs/Observable";
import * as _ from "lodash";
import {CropperSettings, ImageCropperComponent} from 'ng2-img-cropper';
import * as XLSX from 'xlsx';
import csv from 'csv'

declare let swal:any;
declare var $ :any;

@Component({
  selector: 'app-add-bill',
  templateUrl: './add-bill.component.html',
  styleUrls: ['./add-bill.component.css']
})
export class AddBillComponent implements OnInit {

  errors: any = {};
  isLoading: boolean = false;

  targetName: string = '';
  targetFile:File;
  pharmaJSON: any = [];

  contractName: string = '';
  contractFile:File;

  environment: any;
  bill: any = {
    name: '',
    wording: '',
    tva: null,
    tampon: false
  };

  percentMaskOption: any = { prefix: '', thousands: ' ', decimal: ',', suffix: ' %', align: 'left', allowNegative: false };

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private utilsService: UtilsService,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.environment = environment;

    if (this.authService.currentIsAdmin())
      this.router.navigate(['../..'], {relativeTo: this.route});

    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      this.utilsService.scrollTop();
    });
  }

  pharmaChange(files: any){
    var self = this;
    var fileReader = new FileReader();
    fileReader.onload = function (e) {

      var binary = "";
      var bytes = new Uint8Array(fileReader.result);
      var length = bytes.byteLength;
      for (var i = 0; i < length; i++) {
        binary += String.fromCharCode(bytes[i]);
      }

      if (files[0].type === 'text/csv') {
        csv.parse(binary, { relax_column_count: true, columns: true, auto_parse_date: true, auto_parse: true }, function (err, data) {
          if (!err) {
            for (var i = 0; i < data.length; i++) {
              data[i] = _.mapKeys(data[i], function (v, k) {
                if (/(^|\s)cip($|\s)/gi.test(k)) {
                  return 'cip'
                } else if (/(^|\s)(nom|name)($|\s)/gi.test(k)) {
                  return 'nom'
                } else if (/(^|\s)(cp|code postal)($|\s)/gi.test(k)) {
                  return 'zipcode';
                } else if (/(^|\s)(amount|prix|price)($|\s)/gi.test(k)) {
                  return 'price_ht';
                }
                else {
                  return k.trim().toLowerCase();
                }
              });
            }
            for (var i = 0; i < data.length; i++) {
              if (!data[i]['cip'] || !data[i]['nom'] || !data[i]['email'] || !data[i]['price_ht'] || isNaN(parseFloat(data[i]['price_ht'] ))) {
                data.splice(i, 1);
                i = -1;
              }
            }
          }
          self.pharmaJSON = _.cloneDeep(data);
        });
      }

      else {
        var oFile = XLSX.read(binary, {type: 'binary'});
        var dataJson = XLSX.utils.sheet_to_json(oFile.Sheets[oFile.SheetNames[0]], { raw: true });

        for (var i = 0; i < dataJson.length; i++) {
          dataJson[i] = _.mapKeys(dataJson[i], function (v, k) {
            if (/(^|\s)cip($|\s)/gi.test(k)) {
              return 'cip'
            } else if (/(^|\s)(nom|name)($|\s)/gi.test(k)) {
              return 'nom'
            } else if (/(^|\s)(cp|code postal)($|\s)/gi.test(k)) {
              return 'zipcode';
            } else if (/(^|\s)(amount|prix|price)($|\s)/gi.test(k)) {
              return 'price_ht';
            } else {
              return k.trim().toLowerCase();
            }
          });
        }
        for (var i = 0; i < dataJson.length; i++) {
          if (!dataJson[i]['cip'] || !dataJson[i]['nom'] || !dataJson[i]['email'] || !dataJson[i]['price_ht'] || isNaN(parseFloat(dataJson[i]['price_ht'] ))) {
            dataJson.splice(i, 1);
            i = -1;
          }
        }
        self.pharmaJSON = _.cloneDeep(dataJson);
      }

    };
    fileReader.readAsArrayBuffer(files[0]);

    this.targetName = files[0].name;
    this.targetFile = files[0];
  }

  valueChange(field) {
    delete this.errors[field];
  }

  cancelSubmit() {
    this.router.navigate(['../..'], {relativeTo: this.route});
  }

  togglePopup(form) {
    let flag = 0;
    if (this.pharmaJSON.length == 0) {
      this.utilsService.displayNotif("Vous devez ajouter un fichier pharmacie valide", "danger");
      flag = 1;
    }

    if (flag == 1 || form.invalid)
      return;

    var pharmaStr = "";
    for (var i in this.pharmaJSON) {
      pharmaStr += '<tr><td class="text-left">' + this.pharmaJSON[i].cip + '</td><td class="text-left">' + this.pharmaJSON[i].nom + '</td><td class="text-left">' + this.pharmaJSON[i].price_ht + '€</td></tr>';
    }
    var self = this;
    $(document).on('click', ".seePharmaListButton", function() {
      swal({
        title: 'Liste des pharmacies',
        html: '<div class="col-xs-12 table-responsive no-padding" style="max-height: 500px">' +
        '<table class="table table-striped primary sortable-table">' +
        '<div class="col-xs-12 table-responsive no-padding">' +
        '<table class="table table-striped primary sortable-table">' +
        '<thead>' +
        '<tr>' +
        '<th>CIP</th>' +
        '<th>Nom de la pharmacie</th>' +
        '<th>Prix</th>' +
        '</tr>' +
        '</thead>' +
        '<tbody>' +
        pharmaStr +
        '</tbody>' +
        '</table>',
        type: 'info',
        customClass: 'pharma-list-modal'
      }).then(() => {
        self.openPopup(form);
      }, () => {
        self.openPopup(form);
      });
    });
    self.openPopup(form);
  }

  openPopup(form) {
    swal({
      title: 'Attention',
      html: "Si vous avez sélectionné la liste des pharmacies ci-dessous, l’envoi des factures à chacune d’entre elle relèvera de votre responsabilité. " +
      "Attention, vous avez sélectionné " + this.pharmaJSON.length + " pharmacies, vous serez contacté par le support sous 24h afin de valider ce devis.<br><br>" +
      "<button type='button' class='btn btn-success col-xs-12 seePharmaListButton'>Voir la liste des pharmacies</button><br><br>",
      type: 'warning',
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonColor: '#49B0D6',
      cancelButtonColor: '#E74C3C',
      cancelButtonText: 'Non',
      confirmButtonText: 'Oui'
    }).then(() => {
      this.submitForm(form);
    }, () => {

    });
  }

  submitForm(form) {
    this.errors = {};

    var flag = 0;

    var formData = new FormData();

    formData.append('name', this.bill.name);
    formData.append('wording', this.bill.wording);
    formData.append('tva', this.bill.tva);
    formData.append('tampon', this.bill.tampon);

    if (this.targetFile == undefined) {
      this.utilsService.displayNotif("Vous devez ajouter un fichier pharmacie", "danger");
      flag = 1;
    }
    else
      formData.append('target', this.targetFile);

    if (flag == 0 && !form.invalid) {
      this.isLoading = true;

      let query = this.authService.session.user.account_type === 'admin' ? "?connectedAs" + this.authService.connectedAs.id : '';

      if (this.authService.session.user.account_type === 'admin') {
        if (!this.authService.currentIsAdmin()) {
          formData.append('laboratory_id', this.authService.connectedAs.id);
        }
        else {
          this.router.navigate(['../..'], {relativeTo: this.route});
        }
      }

      this.http.post(environment.API_PATH + '/bill/add' + query , formData, {withCredentials: true} )
      .subscribe(_ => {
        this.isLoading = false;
        this.utilsService.displayNotif('La facture a bien été créé', 'success');
        this.router.navigate([this.router.url.split('/')[1], 'factures']);
      }, err => {
        this.isLoading = false;
        if (err.status === 401) {
          var errors = err.error;
          if (errors.error) {
            if (errors.error.status === 401) {

              this.router.navigate(['/connexion']);
            } else if (errors.error.status === 403) {
              if (errors.error.details.redirect)
                this.router.navigate([errors.error.details.redirect]);
              else if (errors.error.redirect) {
                this.router.navigate([errors.error.redirect]);
              }
              else
                this.authService.logout()
            } else {
              this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
            }
          } else {
            this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
          }
        } else if (err.status == 400) {
          var details = err.error.error.details;
          if (!_.isEmpty(details)) {
            this.authService.logout();
          }
        }
        else {
          this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
        }
      });
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/add-bill/add-bill.component.ts